"use client";

import { cn } from "@/lib/utils";
import Image from "next/image";
import Link from "next/link";
import AppContainer from "../appContainer";
import { FlexBetween, FlexCenter } from "../ui";
import { footerLinks, footerSocialLinks } from "@/constants";
import { useTranslations } from "next-intl";
import ExpandableText from "@/components/expandableText";
import BazarImage from "public/badge-new.webp";

interface FooterProps {
  className?: string;
}

const ENAMAD_ID = "748269";
const ENAMAD_CODE = "1JcNzhX6TCKD9wJbD5WphNLWvhn4Xtyk";
const ENAMAD_URL = `https://trustseal.enamad.ir/?id=${ENAMAD_ID}&Code=${ENAMAD_CODE}`;
const ENAMAD_LOGO_URL = `https://trustseal.enamad.ir/logo.aspx?id=${ENAMAD_ID}&Code=${ENAMAD_CODE}`;

export default function FooterSection({ className }: FooterProps) {
  const t = useTranslations();
  // const { isMobile } = useTailwindBreakpoints();
  return (
    <footer className={cn("bg-primary-main relative w-full", className)}>
      {/*{!isMobile && (*/}
      {/*  <div className={cn("absolute inset-0 z-10 h-full w-full opacity-50")}>*/}
      {/*    <Image*/}
      {/*      loading="eager"*/}
      {/*      src={WavyPattern}*/}
      {/*      alt="hero section"*/}
      {/*      style={{*/}
      {/*        width: "100%",*/}
      {/*        height: "100%",*/}
      {/*        objectFit: "cover",*/}
      {/*      }}*/}
      {/*    />*/}
      {/*  </div>*/}
      {/*)}*/}
      <AppContainer
        className={cn(
          "relative z-20 size-full sm:max-w-[700px] lg:max-w-[900px] xl:max-w-[1000px]",
        )}
      >
        <FlexBetween
          className={cn(
            "mx-auto w-full flex-wrap items-start gap-y-8 py-12 sm:gap-4",
          )}
        >
          {footerLinks.map(({ items, title, id }) => {
            return (
              <section
                key={id}
                className={cn(
                  "flex flex-col gap-5 text-white xl:gap-10",
                  title === t("footer.contactUs") &&
                    "order-4 w-full sm:order-first sm:w-max",
                )}
              >
                <h3 className={cn("text-xs font-bold lg:text-lg")}>
                  {t(title as any)}
                </h3>
                {id === "contact" ? (
                  <ul className="flex flex-col gap-5 text-[9px] sm:text-xs lg:text-base">
                    {/*<li className="flex items-center gap-2">*/}
                    {/*  <span className="h-5 w-5 lg:h-6 lg:w-6">*/}
                    {/*    <OlMapPointWave*/}
                    {/*      size={0}*/}
                    {/*      className={cn("text-secondary-main! size-full!")}*/}
                    {/*    />*/}
                    {/*  </span>*/}
                    {/*  <p className="dir-ltr flex items-center">*/}
                    {/*    {t("footer.address")}*/}
                    {/*  </p>*/}
                    {/*</li>*/}
                    {/*<li className="flex items-center gap-2">*/}
                    {/*  <span className="h-5 w-5 lg:h-6 lg:w-6">*/}
                    {/*    <OlClockCircle*/}
                    {/*      size={0}*/}
                    {/*      className={cn("text-secondary-main! size-full!")}*/}
                    {/*    />*/}
                    {/*  </span>*/}
                    {/*  <p className="dir-ltr flex items-center">*/}
                    {/*    {t("footer.workingHours")}*/}
                    {/*  </p>*/}
                    {/*</li>*/}
                    <li className="flex items-center gap-2">
                      <Link
                        href="https://cafebazaar.ir/app/co.median.android.odxmyoe"
                        title="دانلود اپ نوین ان"
                        className="w-[150px] lg:w-[170px]"
                      >
                        <Image
                          src={BazarImage}
                          alt="دانلود اپ نوین ان"
                          style={{ width: "100%", height: "100%" }}
                          title="دانلود اپ نوین ان"
                        />
                      </Link>
                    </li>
                  </ul>
                ) : (
                  <ul className="grid auto-cols-max grid-flow-col grid-rows-4 gap-5 text-[9px] sm:text-xs lg:text-base">
                    {items.map(({ label, icon, href }, idx) => (
                      <li className="flex items-center gap-2" key={idx}>
                        {!icon ? (
                          <span className="bg-secondary-main h-2 w-2 rounded-full" />
                        ) : (
                          <span className="h-5 w-5 lg:h-6 lg:w-6">{icon}</span>
                        )}
                        <p className="dir-ltr flex items-center">
                          {!href ? (
                            t(label as any)
                          ) : (
                            <Link
                              id={`footer-link-${idx}`}
                              title={t("footer.linkTitle")}
                              href={href}
                              className="hover:text-secondary-main transition-colors"
                            >
                              {t(label as any)}
                            </Link>
                          )}
                        </p>
                      </li>
                    ))}
                  </ul>
                )}
              </section>
            );
          })}
          <section className={cn("flex flex-col gap-5 xl:gap-10")}>
            <h3 className={cn("text-xs font-bold text-white lg:text-lg")}>
              {t("footer.licenses")}
            </h3>
            <a
              id="footer-enamad"
              referrerPolicy="origin"
              target="_blank"
              rel="noopener"
              title="اینماد نوین وان"
              href={ENAMAD_URL}
              className={cn(
                "flex flex-col justify-between gap-4 overflow-hidden rounded-md bg-white shadow",
              )}
            >
              <img
                title="اینماد نوین وان"
                alt=""
                referrerPolicy="origin"
                src={ENAMAD_LOGO_URL}
                className="h-10 w-10 sm:h-15 sm:w-15 lg:h-20 lg:w-20"
                style={{ cursor: "pointer" }}
                {...{ code: ENAMAD_CODE }}
              />
            </a>
          </section>
        </FlexBetween>
        <FlexCenter className="mt-3">
          <div className="flex items-center">
            {footerSocialLinks.map((item) => (
              <div
                key={item.id}
                className="mx-2 flex max-w-[30px] items-center justify-center"
              >
                <Link
                  id={`footer-social-${item.id}`}
                  href={item.href}
                  title={t(item.title as any)}
                  target="_blank"
                  rel="noopener"
                  className="hover:text-secondary-main text-gray-100 transition-transform duration-300 ease-in-out hover:scale-90"
                >
                  {item.icon}
                </Link>
              </div>
            ))}
          </div>
        </FlexCenter>
        <ExpandableText
          btnId="footer-expandable"
          className="mb-8 text-right text-white"
          gradientColor="from-primary-main"
          collapsible
        >
          <h2 className="heading-2 mt-0">سامانه استعلام نوین</h2>
          <p className="paragraph text-gray-200">
            سامانه استعلام نوین وان، ارائه‌دهنده خدمات استعلامی آنلاین در
            حوزه‌های بانکی، دولتی، حقوقی و خودرویی است. با هدف صرفه‌جویی در
            زمان و هزینه کاربران، امکان دریافت استعلامات رسمی را بدون نیاز به
            مراجعه حضوری و در کوتاه‌ترین زمان ممکن فراهم می‌کنیم.
            <br />
            <strong>خدمات ما:</strong> استعلام چک برگشتی · شماره شبا · خلافی
            خودرو · نظام وظیفه · کد پستی · اطلاعات شرکت‌ها · گذرنامه · و بیش
            از 50 سرویس دیگر
          </p>
        </ExpandableText>
      </AppContainer>
      <section
        className={cn(
          "bg-hero-section-main flex h-8 w-full items-center justify-center lg:h-11",
        )}
      >
        <p className={cn("text-xs text-white lg:text-sm")}>
          {t("footer.copyright")}
        </p>
      </section>
    </footer>
  );
}
